import React from "react";
import styled from "@emotion/styled";
import { mq } from "@utils/media-query/mediaQuery";
import { DangerouslyHtml } from "@components/item";

const Container = styled.div(({ theme }) => ({
  background: theme.color.white,
  width: "100%",
  padding: "1.5rem 2rem 2rem",

  [mq("tablet")]: {
    padding: "2rem 2rem 0",
  },

  [mq("desktop")]: {
    padding: "4rem",
  },
}));

const TitleWrapper = styled.div(() => ({
  textAlign: "center",
  fontSize: "1.6rem",

  [mq("tablet")]: {
    margin: "3.5rem 0",
  },
}));

const WelcomeText = styled.div(() => ({
  marginBottom: "1rem",
  fontSize: "2rem",
  fontWeight: 100,

  span: {
    fontWeight: 700,
  },

  [mq("tablet")]: {
    fontSize: "2.4rem",
  },

  [mq("desktop")]: {
    marginBottom: "2rem",
    fontSize: "3.6rem",
  },
}));

const DateText = styled.div(() => ({
  marginBottom: "1.2rem",
  fontWeight: 700,
  fontSize: "1.2rem",

  [mq("tablet")]: {
    fontSize: "1.4rem",
  },

  [mq("desktop")]: {
    marginBottom: "3.5rem",
    fontSize: "1.6rem",
  },
}));

const Description = styled.div(() => ({
  fontWeight: 200,
  lineHeight: 1.5,
  fontSize: "1.2rem",
  wordBreak: "break-spaces",
  whiteSpace: "pre-wrap",

  [mq("desktop")]: {
    fontSize: "1.8rem",
  },
}));

const WelcomeSection = ({ intlFormat, contents }) => {
  return (
    <Container>
      <TitleWrapper>
        <WelcomeText>
          <span>
            <DangerouslyHtml value={intlFormat(contents.title2)} />
          </span>
        </WelcomeText>

        <DateText>{intlFormat(contents.date)}</DateText>

        <Description>
          <DangerouslyHtml value={intlFormat(contents.description)} />
        </Description>
      </TitleWrapper>
    </Container>
  );
};

export default WelcomeSection;
